<template>
  <v-card
    :class="[cardClass, 'card-base']"
    v-bind="vuetifyOverrideMixin.bindings"
    tabindex="0"
    v-on="$listeners"
    @keyup.enter="$emit('click')"
    @keyup.space="$emit('click')"
  >
    <slot />
  </v-card>
</template>

<script>
import vuetifyOverrideMixin from '~/components/snui/v2/mixins/vuetifyOverrideMixin.vue'

export default {
  name: 'SnBtnCard',
  mixins: [vuetifyOverrideMixin],
  props: {
    focused: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      vuetifyOverrideMixin: {
        overriddenProps: {
          elevation: undefined,
          outlined: false,
          raised: false,
          ripple: false,
          rounded: undefined
        }
      }
    }
  },
  computed: {
    cardClass () {
      let classString = 'card'
      if (this.outlined) classString = 'outlined-card'
      if (this.focused) classString = 'focused-card'
      return classString
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui/index.scss';

  .card-base {
    cursor: pointer;

    &:hover {
      box-shadow: $sn-shadow-depth-4 !important;
    }

    &:active {
      background-color: $sn-brand-01;
      border: 1px solid $sn-brand-03 !important;
      box-shadow: none !important;
    }

    /**
    * Explicit focus style for keyboard focus.
    */
    &:focus,
    &.focus-visible:focus:not(:focus-visible) {
      box-shadow:
        $sn-shadow-depth-4,
          0 0 0 2px $sn-white,
          0 0 0 3px $sn-brand-03 !important;
    }

    /**
    * Remove focus styles for non-keyboard focus.
    */
    &:focus:not(:focus-visible) {
      outline: 0;
      box-shadow: none !important;
    }
  }

  .card {
    box-shadow: $sn-shadow-depth-1 !important;
    border-radius: 8px !important;
    border: 1px solid transparent;
  }

  .outlined-card {
    border: 1px solid $sn-gray-04 !important;
    border-radius: 8px !important;
    box-shadow: none !important;
    height: 100%;
  }

  .focused-card {
    border-radius: 8px;
    border: 1px solid $sn-brand-03;
  }

  .v-card--link:active::before {
    opacity: 0 !important;
  }

  .v-card--link:focus::before {
    opacity: 0 !important;
  }
</style>
